export enum BorderRadii {
  radius4 = 4,
  radius8 = 8,
  radius16 = 16,
  radius24 = 24,
}
